import { lazyNamed } from 'src/utils/lazyNamed';

export { AdMedium } from './containers/AdMedium';
export { AdPrice } from './containers/AdPrices';
export { AdTypes } from './containers/AdTypes';
export { Placement } from './containers/Placements';
export { Products } from './containers/Products';
export { AdMediumMapping } from './containers/AdMediumMapping';

export const Layout = lazyNamed(() => import('./components/Layout'), 'Layout');
